var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40088 19.3115H18.79C20.3921 19.3115 21.3218 18.3818 21.3218 16.6055V7.43311C21.3218 5.65674 20.3838 4.72705 18.5908 4.72705H5.20166C3.59961 4.72705 2.66992 5.64844 2.66992 7.43311V16.6055C2.66992 18.3818 3.60791 19.3115 5.40088 19.3115ZM11.062 12.3057L5.01904 6.3291C5.13525 6.3042 5.26807 6.2876 5.40918 6.2876H18.5825C18.7319 6.2876 18.8647 6.3042 18.9893 6.3374L12.9546 12.3057C12.606 12.646 12.3154 12.7954 12.0083 12.7954C11.7012 12.7954 11.4106 12.6377 11.062 12.3057ZM4.22217 7.54932L8.73779 11.9902L4.22217 16.4561V7.54932ZM15.2788 11.9902L19.7695 7.57422V16.4395L15.2788 11.9902ZM5.40918 17.7427C5.25977 17.7427 5.11865 17.7261 4.99414 17.7012L9.75049 12.9863L10.1987 13.4346C10.8047 14.0239 11.3857 14.2729 12.0083 14.2729C12.6226 14.2729 13.2119 14.0239 13.8096 13.4346L14.2661 12.9863L19.0142 17.6929C18.8813 17.7261 18.7402 17.7427 18.5825 17.7427H5.40918Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.0ef39840.svg";
export { ForwardRef as ReactComponent };